import { superUserPermissionIdsConstants } from "./constants/permission-levels.constants";

export const enum UserPermission {
    ACCOUNT_OWNER = 2,
    OWNER = 2,
    CAMPAIGN_OWNER = 2,
    ACCOUNT_MANAGER = 3,
    CAMPAIGN_MANAGER = 3,
    CAMPAIGN_STAFFER = 4,
    STAFFER = 4,
    LEAD_CANVASSER = 5,
    LEAD_ORGANIZER = 5,
    CANVASSER = 6,
    ORGANIZER = 6,
    REVOKED = 7,
    ORGANISATION_OWNER = 8,
    LEADER_OWNER = 8,
    LEADER_MANAGER = 9,
    ORGANISATION_LEADER = 9,
    DIVISION_MANAGER = 10,
}

export function issuePermissionIds(): number[] {
    return [
        UserPermission.ACCOUNT_OWNER,
        UserPermission.ACCOUNT_MANAGER,
        UserPermission.STAFFER,
        UserPermission.LEADER_OWNER,
        UserPermission.LEADER_MANAGER,
        UserPermission.DIVISION_MANAGER,
    ];
}

export function getLicenseTypeFromPermissionId(id: string | number): string {
    if (superUserPermissionIdsConstants.includes(id as number)) {
        return "super";
    } else {
        return "standard";
    }
}
